var render = function render(){var _vm=this,_c=_vm._self._c;return _c('McPagination',{attrs:{"currentPage":_vm.currentPage,"totalRows":_vm.totalRows,"perPage":_vm.perPage,"pageOptions":_vm.pageOptions,"fields":_vm.fields,"filteredItems":_vm.filteredItems,"rows":_vm.rows},on:{"currentPagePage":_vm.currentPageValue,"newPerPage":_vm.perPageValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }